<template>
  <b-container fluid="sm">
  
    <!--<form class="form-signin"> -->
      
      <b-card no-body>
        <b-tabs pills card align="center">
          <b-tab title="Sign in" active title-item-class="login-tab-item" title-link-class="login-nav-link">
            <b-form @submit.stop.prevent="login">
            <b-container>
              <b-row class="text-center">
                <b-col></b-col>
                <b-col cols="6">
                  <b-alert class="text-left"
                    :show="signinErrors"
                    variant="danger"
                  >{{signinErrorMessage}}</b-alert>
                  <b-form-group
                    id="input-group-1"
                    label="Email address:"
                    label-for="inputEmail"
                  >
                    <b-form-input
                      id="inputEmail"
                      name="inputEmail"
                      v-model="$v.form.emailVal.$model"
                      :state="validateState('emailVal')"
                      
                      placeholder="Enter email"
                      
                      aria-describedby="input-1-live-feedback"
                    ></b-form-input>
                    <b-form-invalid-feedback class="text-left" id="input-1-live-feedback">This is a required field and must be a valid email address.</b-form-invalid-feedback>
                    
                  </b-form-group>

                  <b-form-group
                    id="input-group-2"
                    label="Password:"
                    label-for="inputPassword"
                  >
                    <b-form-input
                      id="inputPassword"
                      name="inputPassword"
                      v-model="$v.form.passwordVal.$model"
                      :state="validateState('passwordVal')"
                      type="password"
                      placeholder="Password"
                      
                      aria-describedby="input-2-live-feedback"
                    ></b-form-input>
                    <b-form-invalid-feedback class="text-left" id="input-2-live-feedback">Please enter your password.</b-form-invalid-feedback>
                  </b-form-group>
                  <b-button type="submit" variant="primary">Sign in</b-button>

                </b-col>
                <b-col></b-col>
              </b-row>
            </b-container>
              
           
          </b-form>
          </b-tab>

          <b-tab title="Sign up" title-item-class="login-tab-item" title-link-class="login-nav-link">
            <b-form @submit.stop.prevent="signup">
            <b-container>
              <b-row class="text-center">
                <b-col></b-col>
                <b-col cols="6">
                  <b-alert class="text-left"
                    :show="signupErrors"
                    variant="danger"
                  >{{signupErrorMessage}}</b-alert>
                  <b-form-group
                      id="input-group-3"
                      label="Email address:"
                      label-for="inputEmailSignup"
                    >
                      <b-form-input
                        id="inputEmailSignup"
                        v-model="$v.signupForm.emailVal.$model"
                        :state="validateSignupState('emailVal')"
                        placeholder="Enter email"
                        aria-describedby="input-3-live-feedback"
                      ></b-form-input>
                      <b-form-invalid-feedback class="text-left" id="input-3-live-feedback">This is a required field and must be a valid email address.</b-form-invalid-feedback>
                    </b-form-group>

                    <b-form-group
                      id="input-group-4"
                      label="Password:"
                      label-for="inputPasswordSignup"
                    >
                      <b-form-input
                        id="inputPasswordSignup"
                        v-model="$v.signupForm.passwordVal.$model"
                        :state="validateSignupState('passwordVal')"
                        placeholder="Password"
                        type="password"
                        aria-describedby="input-4-live-feedback"
                      ></b-form-input>
                      <b-form-invalid-feedback class="text-left" id="input-4-live-feedback">Password must be at least 6 characters long.</b-form-invalid-feedback>
                    </b-form-group>
                    <b-button type="submit" variant="primary">Sign up</b-button>
                  </b-col>
                  <b-col></b-col>
                </b-row>
              </b-container>
            </b-form>
          </b-tab>
        </b-tabs>
      </b-card>
    
  </b-container>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required, minLength, email } from 'vuelidate/lib/validators'

var Parse = require('parse/node');
Parse.initialize(process.env.VUE_APP_PARSE_APP_ID, process.env.VUE_APP_PARSE_JS_KEY);
Parse.serverURL = process.env.VUE_APP_PARSE_SERVER_URL;

export default {

  name: 'LoginComponent',
  components : {
  },
  mixins: [validationMixin],
  data: function () {
    return {
      form : {
        emailVal: "",
        passwordVal: "",
      },
      signupForm : {
        emailVal: "",
        passwordVal: ""
      },
      showSignup: false,
      signinErrors: false,
      signinErrorMessage: "",
      signupErrors: false,
      signupErrorMessage: ""
    }
  },
  validations: {
    form: {
      emailVal: {
        required,
        email
      },
      passwordVal: {
        required
      }
    },
    signupForm: {
      emailVal: {
        required,
        email
      },
      passwordVal: {
        required,
        minLength: minLength(6)
      }
    }  
  },
  methods: {
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },
    validateSignupState(name) {
      const { $dirty, $error } = this.$v.signupForm[name];
      return $dirty ? !$error : null;
    },
    login() {
      this.$v.form.$touch();
      if (this.$v.form.$anyError) {
        return;
      }
      
      Parse.User.logIn(this.form.emailVal, this.form.passwordVal)
        .then((user) => {
          // Used an arrow function here because I 
          // want to access 'this' which is overridden in
          // a conventional function
          console.log('session token ' + JSON.stringify(user));
          localStorage.setItem('parseuser', JSON.stringify(user));
          this.fetchUserFields();
          this.$router.replace("/templates");
        })
        .catch((e) => {
          this.signinErrors = true;
          this.signinErrorMessage = e.message;
        });
    },

    signup() {
      this.$v.signupForm.$touch();
      if (this.$v.signupForm.$anyError) {
        return;
      }

      var user = new Parse.User();
      user.set("username", this.signupForm.emailVal);
      user.set("password", this.signupForm.passwordVal);
      user.set("email", this.signupForm.emailVal);

      //Parse.User.enableUnsafeCurrentUser();
      user.signUp()
      .then((result) => {
        // create company
        console.log('signup result = ' + result);
        localStorage.setItem('parseuser', JSON.stringify(result));
        //const Company = Parse.Object.extend('Company');
        var companyToInsert = new Parse.Object("Company", {
          "Name": this.signupForm.emailVal
        });
        companyToInsert.save()
        .then((companyResult) => {
          // add company id to user record
          user.set("CompanyId", companyResult);
          user.save()
          .then((finalUpdateResult) => {
            console.log('wow this saved everything: ' + finalUpdateResult);
            this.$router.replace("/templates");
          })
          .catch((e) => {
            this.signupErrors = true;
            this.signupErrorMessage = e.message;
          });
        })
        .catch((e) => {
          this.signupErrors = true;
          this.signupErrorMessage = e.message;
        });
      })
      .catch((e) => {
        this.signupErrors = true;
        this.signupErrorMessage = e.message;
      });
    },

    fetchUserFields() {
      const query1 = new Parse.Query(Parse.User);
      if (Parse.User.current()) {
        query1.get(Parse.User.current().id).then((user) => {
          this.$root.$data.companyId = user.attributes.CompanyId.id;
        }, (error) => {
          console.error('Error while fetching user', error);
        });
      }
    }
  }
}
</script>

<style >
.login-tab-item:active {
  background: none !important;
}
.login-nav-link {
  color:#160038 !important;
  background: none !important;
}
.login-nav-link.active {
  color:#160038 !important;
  background: none !important;
  border-bottom: 3px solid #160038 !important;
}
</style>